import {Video} from './video';
import {TitleImage} from './title-image';
import {Episode} from './episode';
import {Season} from './season';
import {Review} from './review';
import {Genre} from '@app/titles/models/genre';
import {Keyword} from '@app/titles/models/keyword';
import {ProductionCountry} from '@app/titles/models/production-country';
import {Person} from '@app/titles/models/person';

export interface EpisodeCredit extends Episode {
  pivot: TitleCreditPivot;
}

export interface TitleCredit extends Person {
  pivot: TitleCreditPivot;
}

export interface PersonCredit extends Title {
  credited_episode_count?: number;
  episodes: EpisodeCredit[];
  pivot: TitleCreditPivot;
}

export interface TitleCreditPivot {
  id: number;
  job: string;
  department: 'directing' | 'writing' | 'actors' | 'creators';
  character: string;
}

export const TITLE_MODEL = 'title';
export const MOVIE_MODEL = 'movie';
export const SERIES_MODEL = 'series';

export interface Title {
  legacy_id: string;
  id: number;
  name: string;
  original_title: string;
  model_type: typeof TITLE_MODEL;
  is_series: boolean;
  status: 'released' | 'upcoming' | 'ongoing' | 'ended';
  description: string;
  display_tagline: string;
  isl_plot: string;
  display_description: string;
  tagline: string;
  isl_tagline: string;
  runtime: number;
  rating: number;
  budget: number;
  poster?: string;
  backdrop: string;
  revenue: number;
  views: number;
  popularity: number;
  seasons_count: number;
  release_date: string;
  year: number;
  genres: Genre[];
  keywords: Keyword[];
  production_countries: ProductionCountry[];
  videos: Video[];
  all_videos?: Video[];
  primary_video: Video;
  primary_video_count?: number;
  certification?: string;
  certificate_type?: {
    id: number;
    name: string;
    display_name: string;
    code: string;
    color?: string;
    background_color?: string;
    image?: string;
  };
  certificateType?: {
    id: number;
    name: string;
    display_name: string;
    code: string;
    color?: string;
    background_color?: string;
    image?: string;
  };
  certificateReasons?: Array<{
    id: number;
    name: string;
    display_name: string;
    description?: string;
    icon?: string;
  }>;
  images: TitleImage[];
  season?: Season;
  seasons?: Season[];
  reviews?: Review[];
  language: string;
  updated_at?: string;
  imdb_rating?: string;
  imdb_votes_num?: number;
  imdb_id?: string;
  rotten_critics?: number;
  rotten_audience?: number;
  tmdb_vote_average?: number;
  tmdb_vote_count?: number;
  metacritic_rating?: number;
  facts?: Array<{
    id: number;
    title?: string;
    text: string;
    image?: string;
    created_at: string;
    updated_at: string;
  }>;
  streaming_availability?: Array<{
    id: number;
    streaming_service: {
      id: number;
      name: string;
      slug: string;
      logo_path: string;
      website_url: string;
    };
    external_id: string;
    url?: string;
    available_from?: string;
    available_until?: string;
    price?: number;
    is_rental: boolean;
    is_purchase: boolean;
  }>;
  showtimes?: Array<{
    id: number;
    date: string;
    time: string;
    room: string;
    type: string;
    language: string;
    subtitle_language: string | null;
    url: string;
    cinema: {
      id: number;
      name: string;
      image: string;
      link: string;
    };
  }>;
}
